/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    /*!*********************************!*\
      !*** ./resources/js/fs-main.js ***!
      \*********************************/
    jQuery(document).ready(function ($) {
      MicroControl = new function () {
        this.vars = {
          token: jQuery('meta[name="csrf-token"]').attr('content')
        };
    
        this.init = function () {
          if(!jQuery('#authenticate').length) {
            MicroControl.dataTables();
          }

          MicroControl.deleteItemAlert();
          jQuery('body').on('click', '.ajax-modal', function (event) {
            event.preventDefault();
            
            var href = jQuery(this).attr('href');
            var modal = jQuery(this).data('bs-target');

            var params = {};
            if (jQuery('input[placeholder="Search File Name"]').val() !== '')     params["file_name"] = jQuery('input[placeholder="Search File Name"]').val();
            if (jQuery('select[name="systems"]').val() !== '')                    params["system"] = jQuery('select[name="systems"]').val();
            if (jQuery('select[name="category_search"]').val() !== '')            params["category"] = jQuery('select[name="category_search"]').val();
            if (jQuery('input[placeholder="Search Version"]').val() !== '')       params["version"] = jQuery('input[placeholder="Search Version"]').val();
            if (jQuery('input[placeholder="Search Description"]').val() !== '')   params["description"] = jQuery('input[placeholder="Search Description"]').val();

            href = ( Object.keys(params).length > 0 ) 
              ? href + '?' + new URLSearchParams(params).toString()
              : href;

            MicroControl.loadAjaxModal(href, modal);
          });
          jQuery('body').on('click', '.copy-text-to-clipboard', function (event) {
            var $temp = jQuery("<input>");
            jQuery("body").append($temp);
            $temp.val(jQuery(this).data('copy-text')).select();
            document.execCommand("copy");
            $temp.remove();
            jQuery(this).append('<span class="clipboard-copy-success">Copied!</span>');
            setTimeout(function () {
              jQuery('.clipboard-copy-success').remove();
            }, 1500);
          });
          jQuery('.disable').on('click', function () {
            if (confirm("Are you sure you want to disable " + jQuery(this).data('name') + "?")) {
              MicroControl.disableUser(jQuery(this).data('id'));
            }
          });
          jQuery('#authenticate').on('click', function () {
            $.ajax({
              url: '/reauthenticate/send',
              type: 'GET',
              data: {},
              showloader: true,
              success: function success(response) {
                $('#alerts').empty();
                $('#alerts').append('<div class="alert alert-success" role="alert"><i class="fas fa-check"></i> Reauthentication email sent!</div>');
              }
            });
          });
        };
        /**
         * Build data tables with individual column filters
         */
    
    
        this.dataTables = function () {
          var default_sort = 0;
          jQuery('.data-table-no-search th').each(function (index, el) {
            if (jQuery(el).hasClass('default-sort')) {
              default_sort = index;
            }
          });
          $('.data-table-no-search').DataTable({
            "searching": false,
            "order": [[default_sort, "asc"]],
            "fnDrawCallback": function fnDrawCallback(oSettings) {
              if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                $(oSettings.nTableWrapper).find('.dataTables_info').hide();
              } else {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                $(oSettings.nTableWrapper).find('.dataTables_info').show();
              }
            }
          });
          var default_sort = 0;
          jQuery('.data-table th').each(function (index, el) {
            if (jQuery(el).hasClass('default-sort')) {
              default_sort = index;
            }
          });
          $('.data-table thead th').each(function () {
            var title = $(this).text();
            var urlParams = new URLSearchParams(window.location.search);

            var baseInput = '<input type="text" placeholder="Search ' + title + '" />';

            if (title == 'Role') {
              var role = jQuery('select[name="role"]');
              jQuery(this).append(role);
            } else if (title == 'File Name') {
              var input = ( urlParams.has('file_name') )
                ? '<input type="text" placeholder="Search ' + title + '" value="' + urlParams.get('file_name') + '" />' 
                : baseInput;
              jQuery(this).append(input)
            } else if (title == 'Version') {
              var input = ( urlParams.has('version') )
                ? '<input type="text" placeholder="Search ' + title + '" value="' + urlParams.get('version') + '" />' 
                : baseInput;
              jQuery(this).append(input)
            } else if (title == 'Description') {
              var input = ( urlParams.has('description') )
                ? '<input type="text" placeholder="Search ' + title + '" value="' + urlParams.get('description') + '" />' 
                : baseInput;
              jQuery(this).append(input)
            } else if (title == 'Approved') {
              var approved = jQuery('select[name="approved"]');
              jQuery(this).append(approved);
            } else if (title == 'Groups') {
              var groups = jQuery('select[name="groups"]');
              jQuery(this).append(groups);
            } else if (title == 'System' || title == 'Systems') {
              var systems = jQuery('select[name="systems"]');
              if ( urlParams.has('system') ) systems.val(urlParams.get('system'));
              jQuery(this).append(systems);
            } else if (title == 'Status') {
              var statuses = jQuery('select[name="status_search"]');
              jQuery(this).append(statuses);
            } else if (title == 'Category') {
              var categories = jQuery('select[name="category_search"]');
              if ( urlParams.has('category') ) categories.val(urlParams.get('category'));
              jQuery(this).append(categories);
              console.log(categories);
            } else if (title == 'User Count') {} else if (title == 'File Size') {} else if (title != 'Action') {
              jQuery(this).append(baseInput);
            }
          });
          var table = $('.data-table').DataTable({
            dom: 'Qlfrtip',
            "order": [[default_sort, "asc"]],
            "columns" : Array.from(document.querySelector('.data-table').querySelectorAll('th')).map(
              el => {
                if (el.textContent.toLowerCase() === "file size") return { sType: 'filesize' };
                return {};
              }
            ),
            "fnDrawCallback": function fnDrawCallback(oSettings) {
              if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                $(oSettings.nTableWrapper).find('.dataTables_info').hide();
              } else {
                $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                $(oSettings.nTableWrapper).find('.dataTables_info').show();
              }
            },
            initComplete: function initComplete() {
              this.api().columns().every(function () {
                var that = this; //Contains string text field
    
                jQuery('input', this.header()).on('keyup change clear', function () {
            
                  var thisval = $.fn.dataTable.util.escapeRegex(this.value);
    
                  if (that.search() !== thisval) {
                    that.search(thisval).draw();
                  }
                }); //Contains string select field  
    
                jQuery('select', this.header()).on('keyup change clear', function () {
                  var thisval = this.value.replace(';', '');
                  
                  if (that.search() != thisval) {
                    if (this.name == 'Role') {
                      that.search("^" + thisval + "$", true, false).draw();
                    } 
                    else if (this.name === 'systems') {
                      thisval = thisval.trim();
                      console.log(thisval);
                      if (thisval.includes("LC-2")) {
                        if(thisval.length == 4){
                          thisval = "LC-2";
                        }
                        else if(thisval == "LC-2Automation"){
                          thisval = "LC-2Automation";
                        }
                        else if(thisval.length == 5){
                          thisval = "LC-2+";
                        }
                        
                        // thisval = thisval + "[^+A]";
                      } else {
                        thisval = $.fn.dataTable.util.escapeRegex(thisval);
                      }
                      thisval = thisval + ' ';
                      
                      that.search(thisval, true, true).draw();
                    } 
                    else {
                      that.search(thisval).draw();
                    }
		              }
                }); 
                jQuery('body').on('click', '.data-table input, .data-table select', function(event) {
                  event.stopPropagation();
                });

                jQuery('input', this.header()).trigger( "change" );
                jQuery('select', this.header()).trigger( "change" );

                jQuery.extend( jQuery.fn.dataTableExt.oSort, {
                  'filesize-pre': function ( a ) {
                    if ( a === 'N/A' ) {
                      return -1;
                    }
                    var x = parseFloat( a.replace('KB', '').trim() );
                    return x; 
                  },
                  'filesize-asc': function ( a, b ) {
                    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
                  },
                  'filesize-desc': function ( a, b ) {
                    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
                  },
                } )

	      });
	    },
	  });
        };
        /**
         * Load dynamic content into a bootstrap modal
         *
         * @param string href - ajax route to load
         * @param string modal - id of modal to open
         */
    
    
        this.loadAjaxModal = function (href, modal) {
          $.ajax({
            url: href,
            type: 'GET',
            showloader: true,
            success: function success(response) {
              $(modal).find('.modal-body').html(response);
              $(modal).modal('show');
            }
          });
        };
        /**
         * Triggers a confirm window when customer tries to delete an item
         */
    
    
        this.deleteItemAlert = function () {
          jQuery('body').on('click', '.delete-item-alert', function (event) {
            var r = confirm("Are you sure you want to delete this item?");
    
            if (r == true) {
              return true;
            } else {
              return false;
            }
          });
        };
        /**
         * Load dynamic content into a bootstrap modal
         *
         * @param string href - ajax route to load
         * @param string modal - id of modal to open
         */
    
    
        this.disableUser = function (disabledUserId) {
          $.ajax({
            url: '/users/disable',
            type: 'GET',
            data: {
              disabledUserId: disabledUserId,
              _token: MicroControl.vars.token
            },
            success: function success(response) {
              if (response.status == 'success') {
                jQuery('.page-header').after('<div class="alert alert-warning" role="alert">' + '<i class="far fa-exclamation-triangle"></i> ' + response.message + '</div>');
                jQuery("button[data-id='" + disabledUserId + "']").hide();
                jQuery("button[data-id='" + disabledUserId + "']").parent().prev().html('No');
              } else {
                jQuery('.page-header').after('<div class="alert alert-danger" role="alert">' + '<i class="fas fa-times"></i> ' + response.message + '</div>');
              }
            }
          });
        };
      }();
      MicroControl.init();
    });
    /******/ })()
    ;
    //# sourceMappingURL=fs-main.js.map
